export default __webpack_public_path__ + "poland.65f642c0.png";